import { render, staticRenderFns } from "./DeliveryNoteLayout.vue?vue&type=template&id=5e5193e4&scoped=true&"
import script from "./DeliveryNoteLayout.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5193e4",
  null
  
)

export default component.exports